/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentLock } from '../../models/document-lock';

export interface DocumentLockDocument$Params {

/**
 * GUID of the document
 */
  documentId: string;
}

export function documentLockDocument(http: HttpClient, rootUrl: string, params: DocumentLockDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentLock>> {
  const rb = new RequestBuilder(rootUrl, documentLockDocument.PATH, 'post');
  if (params) {
    rb.path('documentId', params.documentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentLock>;
    })
  );
}

documentLockDocument.PATH = '/document/{documentId}/lock';
